import axios from "axios";

// Determine API base URL:
// 1. If REACT_APP_API_URL is set in environment, use it (for separate deployments)
// 2. If on production (not localhost), use empty string for same-domain requests
// 3. Otherwise use localhost:5000 for local development
const getAPIBaseURL = () => {
  // Check if environment variable is set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Check if we're in development (localhost)
  const isDevelopment =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // In production (VPS), use same domain; in development, use localhost backend
  return isDevelopment ? "http://localhost:5000" : "";
};

const API_BASE_URL = getAPIBaseURL();

console.log(`🌐 API Base URL: ${API_BASE_URL || "(same domain)"}`);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to dynamically add the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
      console.log(`🔑 Using token for request: ${config.url}`);
    } else {
      console.warn("⚠️ No token found in localStorage");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle network/connection errors (backend not available)
    if (!error.response) {
      console.warn(
        "⚠️ Backend not available - Please ensure the server is running",
      );
      // Don't redirect or crash, just return the error for the calling code to handle
      return Promise.reject({
        ...error,
        message: "Backend server is not available. Please try again later.",
      });
    }

    if (error.response?.status === 401 || error.response?.status === 403) {
      const errorData = error.response?.data;

      // Log the specific auth error
      if (errorData?.expired) {
        console.error("❌ Token expired - session timed out after 24 hours");
      } else if (errorData?.invalid) {
        console.error("❌ Token invalid - unauthorized access attempt");
      } else {
        console.error("❌ Authentication failed:", errorData?.message);
      }

      // Clear invalid token and redirect to login
      localStorage.removeItem("token");
      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/register"
      ) {
        console.log("🔄 Redirecting to login...");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
